module.exports = "/_next/static/images/ConnectAndSync@2x-848d49acfa29c7fadbd86305e2959280.png";